<template>
  <div class="home" id="home" :class="{'hide-branding': hideBranding}">
    <Logo v-if="!hideBranding" :homepage="homepage" />
    <h3 v-if="!findError">
      Please enter your presentation's access code:
    </h3>
    <h3 v-if="findError">
      Presentation not found. You may have mistyped the access code. Try again?
    </h3>

    <form @submit.prevent="submitAccessCode" class="item-input">
      <input
        type="text"
        class="item-input-text submit-access-placeholder"
        placeholder="Type in access code..."
        v-model="accessCode"
        @input="handleAccessCode"
        :maxlength="10"
        required
      >
      <div class="text-center">
        <ui-button type="submit" size="lg">
          <span>Submit</span>
          <span class="w-20px h-20px">
            <i class="fas fa-check" v-if="!submiting" />
            <ui-spinner v-else />
          </span>
        </ui-button>
      </div>
      <div class="text-danger text-center" v-if="error" style="line-height: 1.5rem">
        <i class="fa fa-exclamation-triangle fa-fw" aria-hidden="true" />
        <span v-html="error" />
      </div>
    </form>

    <p class="note text-center">
      The code is found on the screen in front of you.
    </p>
  </div>
</template>

<script>
// UI
import UiButton from '@/components/UI/Button'
import UiSpinner from '@/components/UI/Spinner'

import Config from '@/config'
import Util from '@/util'
import Logo from '@/components/Logo'

export default {
  name: 'Home',
  components: {
    Logo,
    UiButton,
    UiSpinner,
  },
  data() {
    return {
      accessCode: '',
      error: '',
      submiting: false,
      findError: false,
      hideBranding: false,
      homepage: true,
    }
  },
  created() {
    this.findError = Util.getParamValue('error', window.location.href)
    if (this.findError) {
      window.history.replaceState('', '', '/')
    }
  },
  mounted() {
    if (document.getElementById('slide-image-bg')) {
      document.getElementById('slide-image-bg').remove()
    }
    document.body.style.backgroundColor = '#ffffff'
    document.body.style.color = '#313131'

    if (window.location.host !== Config.domain) {
      this.hideBranding = true
    }
  },
  methods: {
    submitAccessCode() {
      if (this.submiting) return
      this.submiting = true
      this.error = ''
      this.$http
        .get(Config.api.checkPresentation, {
          params: {
            id: this.accessCode,
          },
        })
        .then(
          (doc) => {
            if (!doc.body) {
              this.error = `There's no such presentation with this access code (<span class="text-uppercase">${this.accessCode}</span>). Please try again.`
              this.submiting = false
              return
            }
            this.$router.push({
              name: 'Presentation',
              params: { id: doc.body.uniqueAccessCode },
            })
            this.submiting = false
          },
          () => {
            this.submiting = false
            this.error = `There's no such presentation with this access code (<span class="text-uppercase">${this.accessCode}</span>). Please try again.`
          },
        )
    },

    handleAccessCode() {
      this.accessCode = this.accessCode.replace(/\s/g, '')
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";

.home {
  max-width: 710px;
  margin: 0 auto;
}

.note {
  padding: 0 16px;
}

h3 {
  max-width: 500px;
  margin: 0 auto;
  text-align: center;
  margin-bottom: 20px;
  padding: 0 16px;
}
.hide-branding {
  h3 {
    margin-top: 40px;
  }
}

.item-input {
  padding: 0 16px;
  max-width: 500px;
  margin: 0 auto;
  .item-input-text {
    margin-bottom: 16px;
    text-transform: uppercase;
  }

  .button-submit {
    width: 150px;
    .fas {
      margin-bottom: 4px;
    }
  }
}

.text-danger {
  margin-top: 20px;
}
.submit-access-placeholder::placeholder {
  text-transform: none;
}
</style>
